/* eslint-disable import/prefer-default-export */
export const generateFAQ = (data) => {
  if (!data.length) return;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: []
  };

  data.forEach(({ question, answer }) => {
    schema.mainEntity.push({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer
      }
    });
  });

  return schema;
};
